import Select from 'app/frontend/base/components/Select'
import { usePageInfo } from 'app/frontend/base/config/queries'

type Props = {
  className?: string
  value?: string
  setValue: (value?: string) => void
}

const SeasonSelect = ({ className, value, setValue }: Props) => {
  const {
    data: {
      currentExpansion: { seasons },
    },
  } = usePageInfo()

  return (
    <Select
      className={className}
      value={value}
      placeholder='Select season'
      options={seasons.map((season) => ({
        value: season.id.toString(),
        label:
          season.instances.length > 1
            ? `${season.name} (${season.expansion})`
            : season.instances[0].name,
        description:
          season.instances.length > 1
            ? season.instances.map((instance) => instance.name).join(', ')
            : `${season.name} (${season.expansion})`,
        sortLabel: season.name,
      }))}
      setValue={setValue}
    />
  )
}

export default SeasonSelect
